import { Button, Stack, Typography } from '@mui/material';

import Dialog from 'modules/common/components/MUI/Dialog';
import { useMemberPaymentContext } from 'modules/common/components/Payment/MemberPaymentContext';
import { MessageCenterScreen } from 'modules/common/components/Navigator/context/NavigatorContext.interface';
import useIMC from 'modules/IMC/useIMC';
import WarningExclamationIcon from 'modules/common/components/Icons/WarningExclamationIcon';

const TITLE_ID = 'pending-payment-modal-title';
const DESCRIPTION_ID = 'pending-payment-modal-description';

export default function PendingPaymentModal() {
    const { isPaymentPending } = useMemberPaymentContext();
    const { openMessageCenter, currOpenDrawer } = useIMC();

    if (!isPaymentPending) {
        return null;
    }

    const contactSupport = () => {
        openMessageCenter(MessageCenterScreen.NEW_MESSAGE, {
            tags: ['payment-pending'],
            subject: 'Payment Pending - Need Help',
            description: 'There is a pending payment issue with my account. I would like help getting this resolved.',
        });
    };

    return (
        <Dialog
            open
            size="small"
            disableEscapeKeyDown
            aria-labelledby={TITLE_ID}
            aria-describedby={DESCRIPTION_ID}
            disableEnforceFocus
            sx={{
                zIndex: ({ zIndex }) => (currOpenDrawer ? zIndex.drawer - 1 : undefined),
            }}
            heading={<span id={TITLE_ID}>Payment Pending</span>}>
            <Stack direction="column" alignItems="center" gap={1}>
                <WarningExclamationIcon sx={{ color: 'warning.main', fontSize: '48px' }} />
                <Typography id={DESCRIPTION_ID} variant="body1" textAlign="center">
                    We have detected a pending payment issue with your account. Please contact support to resolve it.
                </Typography>

                <Button variant="contained" size="large" onClick={contactSupport} fullWidth sx={{ mt: 2 }}>
                    Contact Support
                </Button>
            </Stack>
        </Dialog>
    );
}
